import React, { useEffect, useState } from "react";
import { apiGet, apiPut } from "@/lib/api";
import { useSEO } from "@/lib/seo";
import { Button } from "@/components/ui/button";
import { inputCls, labelCls } from "@/components/common/states";
import { TRACKING } from "@/lib/tracking";
import { toast } from "sonner";

export default function AdminSettings() {
  const [s, setS] = useState(null);
  useSEO({ title: "Settings · Admin" });

  useEffect(() => { apiGet("/admin/settings").then(setS).catch(() => {}); }, []);

  const set = (k) => (e) => setS((p) => ({ ...p, [k]: e.target.value }));
  const setSocial = (k) => (e) => setS((p) => ({ ...p, social: { ...(p.social || {}), [k]: e.target.value } }));

  const save = async () => {
    const res = await apiPut("/admin/settings", s);
    if (res.success) toast.success("Settings saved"); else toast.error("Save failed");
  };

  if (!s) return <p className="text-muted-foreground">Loading…</p>;

  const trackingRows = [
    ["GTM Container", TRACKING.gtmId || "—"],
    ["GA4 Measurement ID", TRACKING.ga4Id || "(not set — configure to enable GA4)"],
    ["Google Ads Conversion ID", TRACKING.adsConversionId || "(not set)"],
    ["Google Ads Conversion Label", TRACKING.adsConversionLabel || "(not set)"],
    ["Meta Pixel ID", TRACKING.metaPixelId || "(not set)"],
  ];

  return (
    <div className="max-w-2xl">
      <h1 className="font-display text-3xl text-foreground mb-6">Settings</h1>

      <div className="rounded-lg border border-border bg-white p-6 space-y-4">
        <h2 className="font-display text-xl text-foreground">Business Contact</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className={labelCls}>Brand</label><input value={s.brand || ""} onChange={set("brand")} className={inputCls} /></div>
          <div><label className={labelCls}>Tagline</label><input value={s.tagline || ""} onChange={set("tagline")} className={inputCls} /></div>
          <div><label className={labelCls}>Phone</label><input data-testid="settings-phone" value={s.phone || ""} onChange={set("phone")} className={inputCls} /></div>
          <div><label className={labelCls}>WhatsApp</label><input value={s.whatsapp || ""} onChange={set("whatsapp")} className={inputCls} /></div>
          <div><label className={labelCls}>Email</label><input value={s.email || ""} onChange={set("email")} className={inputCls} /></div>
          <div><label className={labelCls}>Address</label><input value={s.address || ""} onChange={set("address")} className={inputCls} /></div>
        </div>
        <div><label className={labelCls}>RERA Disclaimer</label><textarea value={s.rera_disclaimer || ""} onChange={set("rera_disclaimer")} rows={3} className="w-full rounded-md border border-border bg-white px-3 py-2 text-sm outline-none focus:ring-1 focus:ring-primary" /></div>
      </div>

      <div className="rounded-lg border border-border bg-white p-6 space-y-4 mt-6">
        <h2 className="font-display text-xl text-foreground">Social Links</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          {["facebook", "instagram", "linkedin", "youtube", "twitter"].map((k) => (
            <div key={k}><label className={labelCls}>{k}</label><input value={s.social?.[k] || ""} onChange={setSocial(k)} className={inputCls} placeholder="https://…" /></div>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-border bg-white p-6 mt-6">
        <h2 className="font-display text-xl text-foreground mb-1">Marketing & Tracking</h2>
        <p className="text-sm text-muted-foreground mb-4">Configured via environment variables (frontend .env). These are identifiers, not secrets.</p>
        <div className="divide-y divide-border rounded-md border border-border overflow-hidden">
          {trackingRows.map(([label, value]) => (
            <div key={label} className="grid grid-cols-2 p-3 text-sm bg-white">
              <span className="text-muted-foreground">{label}</span>
              <span className="text-foreground font-mono text-xs break-all">{value}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-6"><Button data-testid="settings-save" onClick={save} className="bg-primary text-primary-foreground">Save Settings</Button></div>
    </div>
  );
}
